import { createEvent, forward, restore } from 'effector-root'

export const modalVisibilityChanged = createEvent<boolean>()
export const $modalVisibility = restore(modalVisibilityChanged, false)

export const loadModal = createEvent<{ file: Blob; format: string; filename: string }>()

export const $previewInfo = restore<{ file: Blob; format: string; filename: string }>(
  loadModal,
  null
)

forward({
  from: loadModal,
  to: modalVisibilityChanged.prepend(() => true),
})
